
class KeurigBuyNow extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (this.button) this.button.addEventListener('click', this.handleClick);
  }
  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this.handleClick);
  }
  handleClick = async () => {
    const button = this.button;
    const form = this.closest('form');
    const productForm = this.closest('product-form-component');
    const liveRegion = productForm?.querySelector('[ref="liveRegion"]');
    if (!button || !form || button.disabled) return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    const data = new FormData(form);
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) { if (liveRegion) liveRegion.textContent = 'Please choose an available option.'; return; }
    data.set('id', variantId);
    if (!data.get('quantity')) {
      const quantity = productForm?.querySelector('[name="quantity"]')?.value || productForm?.dataset.quantityDefault || '1';
      data.set('quantity', quantity);
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const original = button.textContent;
    button.textContent = 'Processing…';
    if (liveRegion) liveRegion.textContent = '';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: data, credentials: 'same-origin'
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to continue to checkout.');
      window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
    } catch (error) {
      const message = error?.message || 'Unable to continue to checkout.';
      if (liveRegion) liveRegion.textContent = message;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = original;
    }
  };
}
if (!customElements.get('keurig-buy-now')) customElements.define('keurig-buy-now', KeurigBuyNow);
